import SideBySide from "./SideBySide";
import TopAndBottom from "./TopAndBottom";
import QuestionImageTemplate from "./QuestionImageTemplate";


export const templates = {
    'side-by-side': SideBySide,
    'top-and-bottom': TopAndBottom,
    'question-image-template': QuestionImageTemplate
}